import { render, staticRenderFns } from "./ClubVideos.vue?vue&type=template&id=241ddb98&"
import script from "./ClubVideos.vue?vue&type=script&lang=js&"
export * from "./ClubVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports